import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgStep9 = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32"
    ref={svgRef}
    {...props}
  >
    <circle cx={16} cy={16} r={15} stroke="#DFE1E6" strokeWidth={2} />
    <path
      fill="currentColor"
      d="M15.72 21.792c-1.067 0-1.925-.23-2.576-.688-.65-.459-1.045-1.173-1.184-2.144h2.24c.107.277.277.485.512.624.245.128.608.192 1.088.192.288 0 .555-.043.8-.128.256-.096.48-.261.672-.496.192-.245.347-.576.464-.992.117-.416.192-.95.224-1.6a2.09 2.09 0 01-.512.544 3.34 3.34 0 01-.672.352c-.235.085-.485.15-.752.192a4.758 4.758 0 01-.784.064c-1.13 0-2-.304-2.608-.912-.608-.619-.912-1.488-.912-2.608v-.176c0-.565.101-1.083.304-1.552.203-.47.48-.87.832-1.2a3.702 3.702 0 011.296-.784 4.813 4.813 0 011.648-.272c1.419 0 2.507.416 3.264 1.248.757.832 1.136 2.187 1.136 4.064v.304c0 1.077-.112 1.995-.336 2.752-.224.747-.539 1.36-.944 1.84-.395.48-.87.832-1.424 1.056a4.823 4.823 0 01-1.776.32zm.24-5.936c.576 0 1.024-.16 1.344-.48.33-.32.496-.736.496-1.248v-.16c0-.501-.17-.917-.512-1.248-.33-.33-.773-.496-1.328-.496-.576 0-1.03.165-1.36.496-.32.32-.48.736-.48 1.248v.16c0 .512.16.928.48 1.248.33.32.784.48 1.36.48z"
    />
  </svg>
));
SvgStep9.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgStep9;
